module.exports = __webpack_public_path__ + "static/media/clock-avatar.adfc3a35.svg";